const ruPages = {
    admin: {
        alert: "Код",
        closeAdminPage: {
            title: "Выйти из Администрирования",
            text: "Вы уверены,что хотите закрыть панель Администрирования?",
            okText: "Да, выйти",
        },
        clipboard: {
            error: "Не удалось скопировать код",
            success: "Код скопирован",
        },
        quests: {
            quest: "Задание",
            status: "Статус",
        },
        eqs: {
            eq: "Предмет",
        },
        unique: "Идентификатор",
        pages: {
            page: "Страница",
            id: "ID",
        },
        sound: {
            sound: "Звук",
            force: "Принудительно",
        },
        qr: {
            title: "Qr-код",
        },
        params: {
            param: "Параметр",
            slot: "Слот",
        },
        ifAction: "Условие",
        thenAction: "Действие",
        title: "Администрирование",
        run: "Выполнить",
        target: {
            title: "Выполнить",
            alert: "Вывести код на экран",
            app: "На этом устройстве",
            qr: "Qr-код",
            web: "Отправить пользователю",
        },
        userId: {
            title: "ID Пользователя",
        },
    },
    catalog: {
        title: "Информация",
    },
    codes: {
        title: "Ввод ответа",
        egg: "Поздравляем, вы нашли пасхальное яйцо. Вот оно >>> 🥚 <<<",
        label: "Введите ответ",
        noText: "Укажите ответ",
        notFound: "Ответ %s не найден",
        placeholder: "Введите сюда текст ответа",
    },
    eqs: {
        title: "Предметы",
        noRecords: "У вас еще нет ни одного предмета",
    },
    games: {
        title: "Наши маршруты",
        noRecords: "Нет доступных маршрутов",
        active: "Активна",
        isAdult: "Маршрут имеет рейтинг 18+",
        price: "₽ %s",
        price0: "Бесплатно",
        priceTooltip: "Цена за прохождение маршрута %s руб.",
        confirmData: {
            title: "Открыть маршрут",
            text: 'Вы уверены, что хотите перейти к маршруту "%s"?',
            okText: "Да, перейти",
        },
        errors: {
            getList: "Не удалось получить список маршрутов!",
        },
        game: {
            title: "Наши маршруты",
            go: "Подробнее",
            continue: "Продолжить",
            submit: "Записаться",
            isAdult: "Маршрут имеет рейтинг 18+",
            price: "%s руб.",
            price0: "Бесплатно",
            priceTooltip: "Цена за прохождение маршрута %s руб.",
        },
    },
    map: {
        title: "Карта",
        you: "Я здесь",
        questStatus1: "Задание выполнено",
    },
    params: {
        title: "Параметры",
        activate: {
            title: "Надеть предмет",
        },
        deactivate: {
            title: "Снять предмет",
            text: 'Вы уверены, что хотите снять предмет "%s"?',
            okText: "Снять",
        },
        vgame: {
            startText: `
            <p>Когда-то давно по улицам Владивостока ходили тигры...</p>
            <p>А нет, они и сейчас там ходят!</p>
            <p>Как это возможно?</p>
            <p>Просто они приняли облик людей, наблюдательных и знающих, как тигр на своей территории.</p>
            <p>Хочешь присоединиться к ним?</p>
            <p>Эта игра прокачает твой мозг и ноги, а в конце ты получишь знак тигриной силы - виртуальный амулет и такой же из дерева.</p>
            <p>Начни игру, и всё узнаешь...</p>`,
            buttons: {
                map: "Карта",
                quests: "Задания",
                eqs: "Инвентарь",
                startGame: "Начать",
            },
        },
    },
    quests: {
        title: "Задания",
        noQuests: "У вас еще нет ни одного задания",
        select: "Выбрать",
        status: {
            0: "Активные",
            1: "Выполненные",
            2: "Проваленные",
        },
        variants: "Выберите один из предложенных вариантов",
        showMap: "Показать на карте",
        showInfo: "Показать задание",
    },
    qr: {
        title: "Считать QR-код",
        cameraToggle: "Переключить камеру",
        hint: "Поместите QR-код в центр экрана. Если не считывается, протрите линзу камеры.",
        bagCode: "Данный код сюда не подходит",
        loadingText: "Идет инициализация камеры. Подождите...",
        errors: {
            media: "Ваш Браузер не поддерживает работу с камерой.",
            access: "Нет доступа к камере. Нужно проверить разрешения!",
            notFound: "Не найдено доступных камер!",
            notStart: "Нет доступа к камере!",
            access_denied:
                "Доступ к камере запрещен. Для продолжения работы разрешите доступ к камере в браузере для нашего сайта",
        },
        print: {
            ifAction: "Условие",
            thenAction: "Действие",
            elseAction: "Действие иначе",
        },
    },
    info: {
        title: "Информация",
    },
    payment: {
        title: "Оплата",
    },
    reset: {
        title: "Сброс настроек",
        confirm: {
            title: "Сбросить все настройки",
            text: "Вы уверены, что хотите сбросить все настройки и удалить полученный прогресс?",
            okText: "Да, удалить все",
        },
        reinitDb: {
            error: "Не удалось сбросить Ваши настройки",
            success: "Настройки сброшены",
        },
    },
    user: {
        profile: {
            title: "Профиль",
            fields: {
                name: "Имя",
                email: "E-mail",
                phone: "Телефон",
                game: "Маршрут",
                status: "Статус",
            },
        },
        login: {
            title: "Авторизация",
            toLogin: "Войти",
            toRegistration: "Зарегистрироваться",
            orText: "У вас еще нет учетной записи? Тогда можно:",
            fields: {
                login: "email или номер телефона",
                password: "Пароль",
            },
            notRegister: {
                title: "Регистрация",
                text: "Вы, пока, не зарегистрированы в нашем приложении.",
                okText: "Зарегистрироваться",
                noText: "Позже",
            },
            errors: {
                not_match: "Пароль не подходит",
                bloked: "Ваша учетная запись заблокирована",
                login: "Не удалось авторизоваться",
            },
        },
        logout: {
            title: "Выйти из системы",
            text: "Вы уверены, что хотите выйти из своей учетной записи?",
            okText: "Да, выйти",
        },
        registration: {
            title: "Регистрация",
            toRegistration: "Сохранить",
            required: "Поля помеченные * - обязательны к заполнению",
            agreementAppTitle: "Обработка персональных данных",
            fields: {
                name: "Имя",
                email: "E-mail",
                phone: "Номер телефона",
                password: "Пароль",
                password2: "Пароль еще раз",
                agreementApp: "Я даю согласие на обработку моих персональных данных",
            },
            success: {
                save: "Вы успешно зарегистрировались",
            },
            errors: {
                passwordLength: "Пароль должен иметь не менее 6 символов",
                passwordPattern:
                    "Пароль должен содержать ТОЛЬКО латинские буквы (минимум одну) и арабские цифры  (минимум одну)",
                confirmPassword: "Пароль и подтверждение не совпадают.",
                save: "Не удалось Вас зарегистрировать. Обратитесь в службу поддержки!",
                not_found: "Запись не найдена!",
                register: "Вы уже зарегистрированы в нашем приложении!",
                already_email: "Другой пользователь уже использует этот E-mail",
                already_phone: "Другой пользователь уже использует этот номер телефона",
                agreementApp: "Не удалось загрузить текст согласия на обработку персональных данных",
            },
        },
        adult: {
            title: "18+",
            text: "Данный маршрут имеет возрастное ограничение 18+. Чтобы продолжить, вы должны подтвердить, что вам уже исполнилось 18 лет",
            no: "НЕТ, я младше 18 лет",
            yes: "ДА, мне уже есть 18 лет!",
            noText: "К сожалению, вы не можете поучавствовать в данном маршруте. Но у нас есть и другие.",
            toMainSite: "Посмотреть другие",
            errors: {
                saveAdult: "Не удалось сохранить данные о вашем возрасте. Попробуйте позже!",
            },
        },
        blocked: {
            text: "Ваша учетная запись была заблокирована. Для уточнения, пожалуйста, свяжитесь с нашей техничекой поддержкой.",
        },
    },
};

export default ruPages;
